import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M2 15h10v5h5v-5h5v-5h-10v-5h-5v5h-5l0 5","key":"svg-0"}],["path",{"d":"M7 15v-5h5v5h5v-5","key":"svg-1"}]]

/**
 * IconCubeUnfolded
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY3ViZS11bmZvbGRlZCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMiAxNWgxMHY1aDV2LTVoNXYtNWgtMTB2LTVoLTV2NWgtNWwwIDUiIC8+CiAgPHBhdGggZD0iTTcgMTV2LTVoNXY1aDV2LTUiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/cube-unfolded
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCubeUnfolded = createReactComponent('outline', 'cube-unfolded', 'CubeUnfolded', __iconNode);

export default IconCubeUnfolded;